import React, { createContext, useState, useEffect, useCallback } from "react";
import axios from "axios";
import { BASE_URL } from "../config";

axios.defaults.withCredentials = true;
const AuthContext = createContext();

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loggedIn, setLoggedIn] = useState(null);
  const [loading, setLoading] = useState(true); // New loading state to avoid route flashing
  const [subsection, setSubsection] = useState("OMC");

  const handleSSOSignIn = async () => {
    try {
      // Gets authentication url from backend server
      const {
        data: { url },
      } = await axios.get(`${BASE_URL}/auth/url`);
      // Navigate to consent screen
      window.location.assign(url);
    } catch (err) {
      console.error(err);
    }
  };

  const checkLoginState = useCallback(async () => {
    try {
      const {
        data: { loggedIn: logged_in, user },
      } = await axios({
        method: "GET",
        url: `${BASE_URL}/auth/logged_in`,
        withCredentials: true,
      });

      setLoggedIn(logged_in);
      user && setUser(user);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    checkLoginState();
  }, [checkLoginState]);

  const logout = (logoutNavigate) => {
    setUser(null);
    setLoggedIn(false);
    logoutNavigate();
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        logout,
        loading,
        setLoading,
        checkLoginState,
        loggedIn,
        setLoggedIn,
        handleSSOSignIn,
        subsection,
        setSubsection,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export { AuthProvider, AuthContext };
